import {HomepageLaneType} from "@irati/types"

const HomepageLaneTypesForSlider = [
  HomepageLaneType.AdsPerkboxPicks,
  HomepageLaneType.Company,
  HomepageLaneType.New,
  HomepageLaneType.Other,
  HomepageLaneType.Tag,
  HomepageLaneType.Trending
]

export default HomepageLaneTypesForSlider
